module.exports = __webpack_public_path__ + "static/media/our-values.60d7fb96.jpg";